import { Typography } from "@mui/material";
import AccordionInfo from 'esocial.web.react.lib/cjs/components/simples/campos/AccordionInfo';

export default function InformacoesLimitesRelatorio() {
    return (
        <div style={{ marginBottom: '2rem' }}>
            <AccordionInfo
                titulo="Ver limites a serem observados para a geração de relatórios"
            >
                <Typography variant="body1" fontWeight="bold">
                    Limitação dos formatos de arquivos disponibilizados dos relatórios:
                </Typography>
                <ul style={{ margin: "0.5rem 0" }}>
                    <li>Relatórios de até 1000 linhas: CSV, Excel (xlsx) e PDF</li>
                    <li>Relatórios de 1001 a 20.000 linhas: CSV e Excel (xlsx)</li>
                    <li>Relatórios de 20.001 a 500.000 linhas: CSV</li>
                    <li>Relatórios acima de 500.000 linhas não serão disponibilizados</li>
                </ul>
                <Typography variant="body1">
                    Se o relatório solicitado exceder o limite de linhas do formato desejado, recomendamos emitir mais de um relatório utilizando diferentes parâmetros para reduzir o tamanho do arquivo gerado.
                </Typography>
            </AccordionInfo>
        </div>
    )
}
